import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./RestartSubscriptionForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelRestartSubscription} from "../../actions/AccountApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {showDatePicker} from "../../actions/ViewActions";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "deliveryDate");
  return errors.toJS();
}


class RestartSubscriptionFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("subscriptionId", this.props.subscriptionId);

    return this.props.restartSubscription(updatedValues.toJS())
      .then((response) => {
        if (response.data.restartSubscription.errors.length <= 0) {
          this.props.cancelRestartSubscription();
        } else {
          let errors = createValidationErrors(response.data.restartSubscription.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRestartSubscription();
  }

  handleShowDatePicker(field, date) {
    let data = fromJS(this.props.data.subscriptionRescheduleInfo);
    let unavailableDates = data.get("unavailableDates").reduce((acc, x) => {
      return acc.set(x, "Unavailable");
    }, Map()).toJS();    
    this.props.showDatePicker(field, date, { 
      disableWeekends: true, 
      unavailableDates: unavailableDates,
      notBeforeDate: data.get("notBeforeDate"),
      notAfterDate: data.get("notAfterDate"),
    });
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    const subscriptionRescheduleInfo = fromJS(data.subscriptionRescheduleInfo);
    let initialValues = fromJS({
      deliveryDate: subscriptionRescheduleInfo.get("notBeforeDate")
    })
    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        showDatePicker={this.handleShowDatePicker.bind(this)}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const GET_SUBSCRIPTION = gql`
  query subscriptionInfo($subscriptionId: ID!) {
    subscriptionRescheduleInfo(subscriptionId: $subscriptionId) {
      notBeforeDate
      notAfterDate
      unavailableDates
    }
  }
`;


const RESTART_SUBSCRIPTION = gql`
  mutation restartSubscription($data: RestartSubscriptionInput!) {
    restartSubscription(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(GET_SUBSCRIPTION, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        subscriptionId: props.subscriptionId
      }
    })
  }),
  graphql(RESTART_SUBSCRIPTION, {
    props: ({ mutate }) => ({
      restartSubscription: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);


export default connect(null, {cancelRestartSubscription, showDatePicker})(withQueries(RestartSubscriptionFormContainer));